import { BaseService, GET, Path, Query, QueryMap, Signal } from 'ts-retrofit3';

import type { IResponse } from '@/Module/Core/Model/ApiModel';
import { HttpService } from '@/Module/Core/Service';
import type { ILessonSection } from '@/Module/Lesson/Model/DataModel';
import { TEACHER_API } from '@/Module/Teacher/Constant';
import type { IGetLessonByTeacherId, IGetTeacherListByCategoryId } from '@/Module/Teacher/Model/ApiModel';
import type { ITeacher } from '@/Module/Teacher/Model/DataModel';
import type { ITeacherListByCategory } from '@/Module/Teacher/Model/DataModel/ITeacherListByCategory';

class TeacherService extends BaseService {
  @GET(TEACHER_API.GET_BY_ID)
  async getById(@Path('id') _teacherId: ITeacher['id'], @Signal _signal?: AbortSignal): Promise<IResponse<ITeacher>> {
    return <IResponse>{};
  }

  @GET(TEACHER_API.GET_BY_SEO_URL_SLUG)
  async getBySeoUrlSlug(
    @Query('seoUrlSlug') _seoUrlSlug: ITeacher['seoUrlSlug'],
    @Signal _signal?: AbortSignal,
  ): Promise<IResponse<ITeacher>> {
    return <IResponse>{};
  }

  @GET(TEACHER_API.GET_LESSON_BY_TEACHER_ID)
  async getLessonByTeacherId(
    @QueryMap _query: IGetLessonByTeacherId,
    @Signal _signal?: AbortSignal,
  ): Promise<IResponse<ILessonSection[]>> {
    return <IResponse>{};
  }

  @GET(TEACHER_API.GET_TEACHER_LIST_BY_CATEGORY_ID)
  async getTeacherListByCategoryId(
    @QueryMap _query: IGetTeacherListByCategoryId,
    @Signal _signal?: AbortSignal,
  ): Promise<IResponse<ITeacherListByCategory>> {
    return <IResponse>{};
  }
}

export default HttpService.build(TeacherService);
